<template>
  <el-table
    ref="table"
    v-loading:body="loading"
    :data="data"
    style="width: 100%"
    :size="size"
    highlight-current-row
    :header-row-class-name="headerClassName"
    :row-class-name="rowClassName"
    :border="border"
    :stripe="stripe"
    :height="height"
    :max-height="maxHeight"
    tooltip-effect="dark"
    @selection-change="handleSelectionChange"
    @sort-change="handleSortChange"
    @current-change="handleCurrentChange"
    @row-click="handleRowClick"
    @row-dblclick="handleDbClick"
    :default-expand-all="expandAll"
    :summary-method="summaryMethod"
    :show-summary="showSummary"
    fit
  >
    <template v-for="(column, index) in filterColumns()">
      <el-table-column
        :prop="column.key"
        :type="column.type"
        :align="column.align"
        :selectable="column.selectable"
        v-if="column.type == 'index' || column.type == 'selection'"
        :fixed="column.fixed"
        :key="index"
      ></el-table-column>
      <el-table-column
        :prop="column.key"
        :type="column.type"
        :align="column.align"
        v-else-if="column.type == 'expand'"
        :key="index"
      >
        <template slot-scope="scope">
          <render-column
            v-if="column.render"
            :row="scope.row"
            :render="column.render"
          ></render-column>
          <span v-else>{{ scope.row[column.key] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="column.title"
        v-else-if="column.children"
        :key="index"
        :align="column.align"
      >
        <el-table-column
          v-for="c in column.children"
          :key="c.key"
          :prop="c.key"
          :type="c.type"
          :fixed="c.fixed"
          :sortable="c.sortable"
          :width="c.width"
          :min-width="c.minWidth"
          :label="c.title"
          :show-overflow-tooltip="c.tooltip"
        >
          <template slot-scope="scope">
            <render-column
              v-if="c.render"
              :row="scope.row"
              :render="c.render"
            ></render-column>
            <span v-else>{{ scope.row[c.key] }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        :prop="column.key"
        :type="column.type"
        :align="column.align"
        :fixed="column.fixed"
        :sortable="column.sortable"
        :width="column.width"
        :min-width="column.minWidth"
        :label="column.title"
        v-else
        :key="index"
        :show-overflow-tooltip="column.tooltip"
        v-permission="column.permission"
      >
        <template slot="header" slot-scope="scope">
          <render-column
            v-if="column.renderHeader"
            :row="scope.column"
            :render="column.renderHeader"
          ></render-column>
          <span v-else>{{ scope.column.label }}</span>
        </template>
        <template slot-scope="scope">
          <render-column
            v-if="column.render"
            :row="scope.row"
            :render="column.render"
            :index="scope.$index"
          ></render-column>
          <span v-else>{{ scope.row[column.key] }}</span>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
import RenderColumn from "./RenderColumn";
import { getProviderType } from "@/utils/user";
export default {
  props: {
    size: String,
    data: Array,
    columns: Array,
    loading: Boolean,
    height: Number,
    maxHeight: Number,
    refName: String,
    expandAll: Boolean,
    border: {
      type: Boolean,
      default: false
    },
    stripe: {
      type: Boolean,
      default: false
    },
    headerClassName: {
      type: String,
      default: "theme-table"
    },
    rowClassName: {
      type: Function,
      default: () => ""
    },
    summaryMethod: {
      type: Function,
      default: () => {}
    },
    showSummary: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RenderColumn
  },
  methods: {
    handleSelectionChange(rows) {
      this.$emit("on-selection-change", rows);
    },
    handleSortChange({ column, prop, order }) {
      this.$emit("on-sort-change", { column, prop, order });
    },
    handleCurrentChange(rows) {
      this.$emit("on-current-change", rows);
    },
    handleRowClick(row) {
      this.$emit("on-row-click", row);
    },
    handleDbClick(row) {
      this.$emit("on-row-dblclick", row);
    },
    toggleRowExpansion(row, expanded) {
      this.$refs.table.toggleRowExpansion(row, expanded);
    },
    toggleRowSelection(row, selected) {
      this.$refs.table.toggleRowSelection(row, selected);
    },
    doLayout() {
      this.$refs.table.doLayout();
    },
    filterColumns() {
      let permission = getProviderType();
      const columns = this.columns.filter(item => {
        if (item.permission) {
          const hasPermission = item.permission.includes(permission);
          return hasPermission;
        }
        return true;
      });
      return columns;
    }
  }
};
</script>

<style lang="scss">
.el-tooltip__popper {
  max-width: 500px !important;
}
</style>
